function isValueNumber(value: unknown) {
    if (typeof value !== "number") {
        return false;
    }

    return true;
}

export class FileDownloadService {
    static componentName = "fileDownloadService";
    static $inject = ["$q", "$http", "Blob", "FileSaver"];

    constructor(private $q: ng.IQService, private $http: ng.IHttpService, private Blob: $TSFixMe, private FileSaver: $TSFixMe) {}

    downloadFile(url: string, defaultFileName: string, params?: $TSFixMe): ng.IPromise<string> {
        let deferred = this.$q.defer<string>();

        this.$http.get(url, { responseType: "arraybuffer", params: params }).then(
            (response: $TSFixMe) => {
                if (response.status != 200) {
                    deferred.reject(response);
                    return;
                }
                let type = response.headers("Content-Type");
                let disposition = response.headers("Content-Disposition");
                if (disposition) {
                    let match = disposition.match(/.*filename=\"?([^;\"]+)\"?.*/);
                    if (match[1]) defaultFileName = match[1];
                }
                defaultFileName = defaultFileName.replace(/[<>:"\/\\|?*]+/g, "_");
                let blob = new this.Blob([response.data], { type: type });
                this.FileSaver.saveAs(blob, defaultFileName);
                deferred.resolve(defaultFileName);
            },
            (response: $TSFixMe) => {
                deferred.reject(response);
            }
        );

        return deferred.promise;
    }

    downloadFilePost(url: string, defaultFileName: string, inputData: $TSFixMe): ng.IPromise<string> {
        let deferred = this.$q.defer<string>();

        this.$http.post(url, inputData, { responseType: "arraybuffer" }).then(
            (response: $TSFixMe) => {
                if (response.status != 200) {
                    deferred.reject(response);
                    return;
                }
                let type = response.headers("Content-Type");
                let disposition = response.headers("Content-Disposition");
                if (disposition) {
                    let match = disposition.match(/.*filename=\"?([^;\"]+)\"?.*/);
                    if (match[1]) defaultFileName = match[1];
                }
                defaultFileName = defaultFileName.replace(/[<>:"\/\\|?*]+/g, "_");
                let blob = new this.Blob([response.data], { type: type });
                this.FileSaver.saveAs(blob, defaultFileName);
                deferred.resolve(defaultFileName);
            },
            (response: $TSFixMe) => {
                deferred.reject(response);
            }
        );

        return deferred.promise;
    }

    exportTable(defaultFileName: string, inputData: $TSFixMe): ng.IPromise<string> {
        let deferred = this.$q.defer<string>();

        const data = {
            ...inputData,
            rows: inputData.rows.map((r: $TSFixMe) => ({
                ...r,
                values: r.values.map((v: $TSFixMe) => (isValueNumber(v) ? String(v) : v))
            }))
        };

        this.$http.post("api/export/table", data, { responseType: "arraybuffer" }).then(
            (response: $TSFixMe) => {
                if (response.status != 200) {
                    deferred.reject(response);
                    return;
                }
                let type = response.headers("Content-Type");
                let disposition = response.headers("Content-Disposition");
                if (disposition) {
                    let match = disposition.match(/.*filename=\"?([^;\"]+)\"?.*/);
                    if (match[1]) defaultFileName = match[1];
                }
                defaultFileName = defaultFileName.replace(/[<>:"\/\\|?*]+/g, "_");
                let blob = new this.Blob([response.data], { type: type });
                this.FileSaver.saveAs(blob, defaultFileName);
                deferred.resolve(defaultFileName);
            },
            (response: $TSFixMe) => {
                deferred.reject(response);
            }
        );

        return deferred.promise;
    }
}

angular.module("topline.modules").service(FileDownloadService.componentName, FileDownloadService);